import classNames from 'classnames'

import { CardContainer } from '@apps-common/components/common/CardContainer'
import { IReceiverKpiCardColors } from './receiver-constants'

interface IProps {
  isActive: boolean
  onClick: () => void
  value: any
  text: string
  Icon: any
  color?: IReceiverKpiCardColors
}

export const ReceiverKpiCard: React.FC<IProps> = ({ isActive, onClick, value, text, Icon, color }) => {
  return (
    <CardContainer
      bgClasses={classNames(
        'relative w-full hover:cursor-pointer border-[3px] flex flex-col !px-3 !py-3 !rounded-3xl',
        color?.bg,
        !isActive && color?.border,
        isActive && color?.borderActive
      )}
      onClick={onClick}
    >
      <div
        className={classNames(
          color?.kpiBg,
          'relative min-w-[30px] px-4 py-2 md:min-w-[65px] flex items-center justify-center rounded-full'
        )}
      >
        <div className={classNames(color?.text, 'jost-medium text-[1.1rem] md:text-[1.35rem]')}>{value}</div>
      </div>
      <div className='flex items-end justify-between px-2 mt-3'>
        <div className={classNames(color?.text, 'text-[0.85rem] capitalize')}>{text}</div>
        <div className={classNames(color?.text, 'text-[1rem] md:text-[1.25rem]')}>
          <Icon />
        </div>
      </div>
    </CardContainer>
  )
}
